//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      activeState: 'TX',
      activeLoc: null,
      ordering: [],
      noordering: [],
      showTime: false,
      locations: []
    }
  },
  computed: {
    ...mapState([ 'allLocations', 'location' ])
  },
  mounted() {
    this.locations = [...this.allLocations]
          this.locations.sort(function(a, b) { // alphabetize by city
      var keyA = a.city,
        keyB = b.city
      if (keyA > keyB) return 1
      if (keyA < keyB) return -1
      return 0
    })
    // Adds Burleson to locations
    // const bs = {
    //   id: 180,
    //   name: 'Burleson',
    //   address: '135 W Ellison St.',
    //   city: 'Burleson',
    //   state: 'TX',
    //   zip: '76028',
    //   phone: '817-447-6508'
    // }
    // this.locations.push(bs)
  },
  methods: {
    name(loc) {
      if (loc.name !== 'Fort Worth') {
        return loc.name
      }
      if (loc.address.startsWith('318')) {
        return 'Fort Worth - Sundance Square'
      }
      if (loc.address.startsWith('2950')) {
        return 'Fort Worth – Alliance Town Center'
      }
      if (loc.address.startsWith('4700')) {
        return 'Fort Worth – Cityview'
      }
    },
    async startOrder(loc) {
      let location = await this.$api.getLocation(loc.id)
      this.$store.commit('setLocation', location)
      this.$store.commit('setMenu', null)
      this.$store.commit('setOrder', null)
      this.$store.commit('setOrderTypePicker', true)
    },
    async selectTime(time) {
      if(time == 'close') {
        this.showTime = false
      } else {
        let handoff_time = time
        if(time == 'asap') {
          let earliest = moment(this.location.calendar.default[0].open, 'YYYYMMDD HH:mm')
          let latest = moment(this.location.calendar.default[0].close, 'YYYYMMDD HH:mm')
          if(moment() < earliest) {
            handoff_time = this.location.calendar.default[0].open
          } else if(moment() > latest) {
            handoff_time = this.location.calendar.default[1].open
          } else {
            handoff_time = null
          }
        }
        await this.$api.getMenu(false, true, handoff_time)
        let order = await this.$api.createOrder(handoff_time)
        if(order) {
          this.$router.push('/order/')
        }
      }
    },
    async showLoc(loc, id) {
      console.log(loc)
      if(this.activeLoc == id) {
        this.activeLoc = null
      } else {
        this.activeLoc = id

        // if (loc.city == 'Burleson') return false // Skip start order while Burleson is closed

        if(this.ordering.indexOf(id) < 0 && this.noordering.indexOf(id) < 0) {
          let loc = await this.$api.getLocation(id)
          this.$store.commit('setLocation', loc)
          if(loc.available == true) {
            this.ordering.push(id)
          } else {
            this.noordering.push(id)
          }
        }
      }
    }
  }
}
